import { REQUEST, SUCCESS, FAILURE } from 'app/shared/util/action-type.util';
import { ACTION_TYPES } from './actions';
import { ContactState, initialState } from './state';

export default (state: ContactState = initialState, action): ContactState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.CREAT_CONTACT_FORM):
      return {
        ...state,
        loading: true,
      };

    case SUCCESS(ACTION_TYPES.CREAT_CONTACT_FORM): {
      return {
        ...state,
        contactForm: action.payload.data,
        loading: false,
      };
    }

    case FAILURE(ACTION_TYPES.CREAT_CONTACT_FORM): {
      return {
        ...state,
        loading: false,
      };
    }

    case ACTION_TYPES.RESET: {
      return {
        ...initialState,
      };
    }
    default:
      return state;
  }
};
